import React, { useState } from "react";

const images = ["images/1.png", "images/2.png", "images/3.png"];

const ImageStack = () => {
const [topImage, setTopImage] = useState(images.length - 1); // Default last image on top

const handleClick = (index) => {
  setTopImage(index);
};

return (
    <div className="image-container padding-top-xxl">
      <div className="image-wrapper padding-top-base">
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`slide ${index + 1}`}
            className={`image ${topImage === index ? "top" : ""}`}
            onClick={() => handleClick(index)}
            style={{ zIndex: topImage === index ? 10 : index }}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageStack;